import React, { MouseEvent, useCallback } from 'react';
import {
  EllipsisMenuButton,
  Menu,
  Typography,
  TypographyType,
  TypographyVariant,
} from 'src/components-dummy';
import { MenuActionsStyled, MenuItemStyled } from './RowActionsMenu.styles';

interface RowActionMenuProps {
  menuAnchorElement: HTMLElement | null;
  onMenuClicked: (event: MouseEvent<HTMLElement>) => void;
  onMenuClose: () => void;
  onViewGalleryClick?: () => void;
  onEditGalleryClick?: () => void;
  onDeleteGalleryClick?: () => void;
}

export const RowActionsMenu = ({
  menuAnchorElement,
  onMenuClicked,
  onMenuClose,
  onViewGalleryClick,
  onEditGalleryClick,
  onDeleteGalleryClick,
}: RowActionMenuProps): JSX.Element => {
  const isOpen = Boolean(menuAnchorElement);

  const onItemClick = useCallback(
    onClick => {
      onClick();
      onMenuClose();
    },
    [onMenuClose]
  );

  return (
    <MenuActionsStyled>
      <EllipsisMenuButton onClick={onMenuClicked} isActive={isOpen} />
      <Menu
        open={isOpen}
        anchorEl={menuAnchorElement}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: -4,
          horizontal: 'right',
        }}
      >
        {!!onViewGalleryClick && (
          <MenuItemStyled key='view' onClick={() => onItemClick(onViewGalleryClick)}>
            <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
              View
            </Typography>
          </MenuItemStyled>
        )}
        {!!onEditGalleryClick && (
          <MenuItemStyled key='edit' onClick={() => onItemClick(onEditGalleryClick)}>
            <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
              Edit
            </Typography>
          </MenuItemStyled>
        )}
        {!!onDeleteGalleryClick && (
          <MenuItemStyled key='delete' onClick={onDeleteGalleryClick} shouldHighlightRed>
            <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
              Delete
            </Typography>
          </MenuItemStyled>
        )}
      </Menu>
    </MenuActionsStyled>
  );
};
